import { render } from "./ProductDisplayModal.vue?vue&type=template&id=7efcc84f&scoped=true"
import script from "./ProductDisplayModal.vue?vue&type=script&lang=js"
export * from "./ProductDisplayModal.vue?vue&type=script&lang=js"

import "./ProductDisplayModal.vue?vue&type=style&index=0&id=7efcc84f&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7efcc84f"]])

export default __exports__